import {createSelector} from "reselect";

const advanceTab = (state) => state.advanceTab;

export const getProbeTypes = createSelector(
  advanceTab,
  (data) => data?.probes_types || []
);
export const getSlaveList = createSelector(
  advanceTab,
  (data) =>
    data?.slave_list?.map((eachSlave) => ({label: eachSlave, value: eachSlave})) || []
);
